<script setup lang="ts">
import {defineAsyncComponent, onBeforeMount, PropType, ref} from "vue";
import {ReportPopupContainer} from "@/utils/presenters/interfaces.ts";
import ReportLauncherPlace from "@/utils/presenters/ReportLauncherPlace.ts";
import {useDialogPluginComponent} from "quasar";
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import ReportViewerPlace from "@/utils/presenters/ReportViewerPlace.ts";

const AsyncReportLauncher = defineAsyncComponent(() => import("@/views/ReportLauncher.vue"))
const AsyncReportViewer = defineAsyncComponent(() => import("@/views/ReportViewer.vue"))
let props = defineProps({
  reportInfo: {
    type: Object as PropType<namaTypes.CustomRepInfo>,
    required: true
  },
  place: {
    type: ReportLauncherPlace,
    required: true
  }
});
const {dialogRef, onDialogCancel} = useDialogPluginComponent();

const viewer = ref();
const launcher = ref();
const popupContainer: ReportPopupContainer = {
  block: {
    reportInfo: props.reportInfo
  },
  currentMode: ref("launch"),
  place: props.place
};

onBeforeMount(async () => {
  await start();
});

async function start() {
  if (viewer.value)
    viewer.value.rerun(popupContainer.place);
  else if (launcher.value)
    launcher.value.rerun(popupContainer.place);
}
</script>

<template>
  <q-dialog ref="dialogRef" @hide="onDialogCancel" @keydown.esc="onDialogCancel" persistent :full-width="popupContainer.currentMode.value === 'view'"
            :full-height="popupContainer.currentMode.value === 'view'">
    <q-card class="tw-flex tw-flex-col tw-shadow-none dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light !tw-rounded-none">
      <q-bar class="tw-flex-none tw-text-xs tw-text-namaFontColor-input-light tw-bg-[#CED4DA] dark:tw-bg-[#212529] dark:tw-text-white tw-h-10">
        <q-space/>
        <q-btn dense flat @click="onDialogCancel" title="Close"
               class="nama-btn-hover nama-custom-btn focus:tw-bg-transparent">
          <q-avatar square class="tw-w-5">
            <DialogCloseIcon/>
          </q-avatar>
        </q-btn>
      </q-bar>
      <q-card-section
        class="tw-grow tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-flex-nowrap tw-overflow-y-auto">
        <template v-if="popupContainer.currentMode.value === 'view' && popupContainer.place instanceof ReportViewerPlace">
          <AsyncReportViewer :popupContainer="popupContainer" ref="viewer"/>
        </template>
        <template v-else-if="popupContainer.currentMode.value === 'launch' && popupContainer.place instanceof ReportLauncherPlace">
          <AsyncReportLauncher :popupContainer="popupContainer" ref="launcher"/>
        </template>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
